export default __webpack_public_path__ + "static/media/play-circle-thick.a3146d5c.svg";